import { Injectable, OnDestroy } from '@angular/core';
import { AbstractMeshService } from '../abstract-mesh.service';
import { SensorIndicatorHelper } from './sensor-indicator-helper';

const meshIndex = 1;

@Injectable()
export class SensorIndicatorService
  extends AbstractMeshService<SensorIndicatorHelper>
  implements OnDestroy
{
  constructor() {
    super();
    this.subscribeToSensorLocation();
  }

  private subscribeToSensorLocation() {
    this.subscribeTo(this.store.location$, (location) => {
      if (
        !location ||
        !this.store.state().output.meta.show_3d_distance_location
      ) {
        return;
      }

      if (!this.helpers.has(meshIndex)) {
        this.addHelper(meshIndex, new SensorIndicatorHelper());
      }
      this.getHelper(meshIndex).updatePosition(location);
    });
  }
}
